namespace Matrix.Data {
    export interface SecurityMergePriorityForm {
        Priority: Serenity.IntegerEditor;
        SourceCode: FormatLookupEditor;
        MergeGroup: Serenity.StringEditor;
        DealParentCode: Serenity.BooleanEditor;
        Name: Serenity.BooleanEditor;
        SecurityTypeCode: Serenity.BooleanEditor;
        LocalCurrencyCode: Serenity.BooleanEditor;
        ExposureMultiplier: Serenity.BooleanEditor;
        AssociatedAccountCode: Serenity.BooleanEditor;
        Sedol: Serenity.BooleanEditor;
        RIC: Serenity.BooleanEditor;
        Isin: Serenity.BooleanEditor;
        Cusip: Serenity.BooleanEditor;
        Figi: Serenity.BooleanEditor;
        Ticker: Serenity.BooleanEditor;
        InternalSecurityCode: Serenity.BooleanEditor;
        Issuer: Serenity.BooleanEditor;
        CouponRate: Serenity.BooleanEditor;
        MaturityDate: Serenity.BooleanEditor;
        SpLtRating: Serenity.BooleanEditor;
        SpStRating: Serenity.BooleanEditor;
        MoodysLtRating: Serenity.BooleanEditor;
        MoodysStRating: Serenity.BooleanEditor;
        FitchLtRating: Serenity.BooleanEditor;
        FitchStRating: Serenity.BooleanEditor;
        InternalLtRating: Serenity.BooleanEditor;
        InternalStRating: Serenity.BooleanEditor;
        CountryOfIssueCode: Serenity.BooleanEditor;
        CountryOfRiskCode: Serenity.BooleanEditor;
        CurrencyOfRiskCode: Serenity.BooleanEditor;
        TradeDate: Serenity.BooleanEditor;
        EffectiveDate: Serenity.BooleanEditor;
        BrokerCode: Serenity.BooleanEditor;
        Strategy: Serenity.BooleanEditor;
        OptionStyle: Serenity.BooleanEditor;
        ExerciseStyle: Serenity.BooleanEditor;
        PutOrCall: Serenity.BooleanEditor;
        StrikePrice: Serenity.BooleanEditor;
        StrikeCurrency: Serenity.BooleanEditor;
        Premium: Serenity.BooleanEditor;
        PremiumCcy: Serenity.BooleanEditor;
        PayOrRec: Serenity.BooleanEditor;
        FixedOrFloat: Serenity.BooleanEditor;
        FloatIndex: Serenity.BooleanEditor;
        InflationIndexLag: Serenity.BooleanEditor;
        InterestTerm: Serenity.BooleanEditor;
        Spread: Serenity.BooleanEditor;
        AllIn: Serenity.BooleanEditor;
        InterestCcy: Serenity.BooleanEditor;
        PaymentFrequency: Serenity.BooleanEditor;
        PaymentBusDayConvention: Serenity.BooleanEditor;
        PaymentCalendar: Serenity.BooleanEditor;
        FirstPaymentDate: Serenity.BooleanEditor;
        DayCountBasis: Serenity.BooleanEditor;
        ResetFrequency: Serenity.BooleanEditor;
        ResetBusDayConvention: Serenity.BooleanEditor;
        ResetCalendar: Serenity.BooleanEditor;
        UnderlyerName: Serenity.BooleanEditor;
        UnderlyerCcy: Serenity.BooleanEditor;
        UnderlyerType: Serenity.BooleanEditor;
        ClearerReference: Serenity.BooleanEditor;
        RedCode: Serenity.BooleanEditor;
        CreditEvents: Serenity.BooleanEditor;
        Guarantor: Serenity.BooleanEditor;
        SecurityCode: Serenity.BooleanEditor;
        GicsSector: Serenity.BooleanEditor;
        GicsIndustryGroup: Serenity.BooleanEditor;
        GicsIndustry: Serenity.BooleanEditor;
        GicsSubIndustry: Serenity.BooleanEditor;
        BorrowerCode: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityMergePriorityForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityMergePriority';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityMergePriorityForm.init)  {
                SecurityMergePriorityForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(SecurityMergePriorityForm, [
                    'Priority', w0,
                    'SourceCode', w1,
                    'MergeGroup', w2,
                    'DealParentCode', w3,
                    'Name', w3,
                    'SecurityTypeCode', w3,
                    'LocalCurrencyCode', w3,
                    'ExposureMultiplier', w3,
                    'AssociatedAccountCode', w3,
                    'Sedol', w3,
                    'RIC', w3,
                    'Isin', w3,
                    'Cusip', w3,
                    'Figi', w3,
                    'Ticker', w3,
                    'InternalSecurityCode', w3,
                    'Issuer', w3,
                    'CouponRate', w3,
                    'MaturityDate', w3,
                    'SpLtRating', w3,
                    'SpStRating', w3,
                    'MoodysLtRating', w3,
                    'MoodysStRating', w3,
                    'FitchLtRating', w3,
                    'FitchStRating', w3,
                    'InternalLtRating', w3,
                    'InternalStRating', w3,
                    'CountryOfIssueCode', w3,
                    'CountryOfRiskCode', w3,
                    'CurrencyOfRiskCode', w3,
                    'TradeDate', w3,
                    'EffectiveDate', w3,
                    'BrokerCode', w3,
                    'Strategy', w3,
                    'OptionStyle', w3,
                    'ExerciseStyle', w3,
                    'PutOrCall', w3,
                    'StrikePrice', w3,
                    'StrikeCurrency', w3,
                    'Premium', w3,
                    'PremiumCcy', w3,
                    'PayOrRec', w3,
                    'FixedOrFloat', w3,
                    'FloatIndex', w3,
                    'InflationIndexLag', w3,
                    'InterestTerm', w3,
                    'Spread', w3,
                    'AllIn', w3,
                    'InterestCcy', w3,
                    'PaymentFrequency', w3,
                    'PaymentBusDayConvention', w3,
                    'PaymentCalendar', w3,
                    'FirstPaymentDate', w3,
                    'DayCountBasis', w3,
                    'ResetFrequency', w3,
                    'ResetBusDayConvention', w3,
                    'ResetCalendar', w3,
                    'UnderlyerName', w3,
                    'UnderlyerCcy', w3,
                    'UnderlyerType', w3,
                    'ClearerReference', w3,
                    'RedCode', w3,
                    'CreditEvents', w3,
                    'Guarantor', w3,
                    'SecurityCode', w3,
                    'GicsSector', w3,
                    'GicsIndustryGroup', w3,
                    'GicsIndustry', w3,
                    'GicsSubIndustry', w3,
                    'BorrowerCode', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
